import './ErrorBoundary.scss';

import type { FC, ReactElement } from 'react';
import * as Sentry from '@sentry/react';

interface Props {
  children: ReactElement;
  fallback?: ReactElement;
}

const ErrorBoundary: FC<Props> = (props) => {
  const { children, fallback } = props;

  return (
    <Sentry.ErrorBoundary
      fallback={fallback ?? <ErrorBoundaryMessage />}
      onError={(error) => {
        // Reload the page if the error is due to a missing module. This can
        // occur if the user navigates to a page with a component loaded via
        // a dynamic import after the site has been updated.
        if (
          error instanceof Error &&
          error.message.includes('Failed to fetch dynamically imported module')
        ) {
          location.reload();
        }
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

const ErrorBoundaryMessage: FC = () => {
  return (
    <div className="ErrorBoundary-message">
      <h3>An error has occurred.</h3>
    </div>
  );
};

export default ErrorBoundary;
